import api from "./api";

export default async function getUser() {
    try {
        const response = await api.get('api/report-card/employee/me/');
        return response.data;
    } catch (error) {
        console.error(error);
    }
  }
